/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react/jsx-no-bind */
// import React from 'react';
import React, { Component } from "react"
import moment from 'moment';
import cloneDeep from "lodash/cloneDeep"

export default class incidents extends React.Component {
	apiSelectOptions = [];
	constructor(props) {
		super(props);
		this.state = {
			s3APIStatusJsonOriginal: this.mergeData(),
			apiFilters: [],			
			selectedTimeline: "week",	
			selectedApiService: "ALL",
			activeClass: false
		};
	}

	static propTypes = {
		getComponent: PropTypes.func,
		specSelectors: PropTypes.object,
		specActions: PropTypes.object.isRequired,
		layoutSelectors: PropTypes.object,
		layoutActions: PropTypes.object,
		getConfigs: PropTypes.func.isRequired
	}
	
	async mergeData() {
		try {
			const currentYear = moment().format("YYYY");
			const responses = 	await Promise.all([this.loadData(`/health-status/${currentYear}.json`), this.loadData(`/health-status/${currentYear-1}.json`)]);
			if(responses){
				let s3APIStatusJsonOriginal = [...responses[0], ...responses[1]];
				if(s3APIStatusJsonOriginal){			
					this.setState({ s3APIStatusJsonOriginal: s3APIStatusJsonOriginal });
					let incidents = this.incidentFilters(s3APIStatusJsonOriginal);
					this.setState({ s3APIStatusJsonOriginal: incidents });
					this.serviceFilters(incidents);
					return incidents;
				}
			}
		} catch (error) {
			return [];
		}
		
	}
	incidentFilters(s3APIStatusJson) {
		let incidents = [];
		if(s3APIStatusJson){
			incidents = s3APIStatusJson.filter((api, index) => {
				return api.label === "INCIDENT";
			})
			return incidents;
		} 
	}
	
	handleApiChange = (event) => {
		this.setState({selectedApiService: event.target.value });
	}

	handleTimelineChange = (event) => {
		this.setState({selectedTimeline: event.target.value });
	}

	handleYearChange = (event) => {
		this.setState({selectedYear: event.target.value });
	}

	async loadData (url) {
		url = url+"?"+Date.now();
		return await fetch(url).then(function (response) {
			if (response.ok) {
				return response.json();
			}
			throw new Error('Error message.');
		}).then(function (data) {
			// this.setState({ s3APIStatusJsonOriginal: data });	
			// this.serviceFilters(data);
			return data;
		}.bind(this)).catch(function (err) {
			console.log("failed to load ", url, err.message);
			// this.setState({ s3APIStatusJsonOriginal: [] });
			return [];
		});
	}

	formatData(items){
		let uniqueYearMonths = [
			...new Set(items.map(x => moment(x.date*1000).format("YYYY-MM-DD").substring(0, 7)))
		  ];
		  let uniqueYearMonthsDays = [
			...new Set(items.map(x => moment(x.date*1000).format("YYYY-MM-DD").substring(0, 10)))
		  ];
		  let results = [...new Set(items.map(x => moment(x.date*1000).format("YYYY-MM-DD").substring(0, 4)))].map(
			year => ({
			  year: year,
			  months: uniqueYearMonths.filter(ym => ym.startsWith(year)).map(ym => ({
				month: moment(ym).format("MMMM YYYY"),
				days: uniqueYearMonthsDays.filter(ymd => ymd.startsWith(ym.substring(0, 7))).map(ymd => ({
				  day: moment(ymd).format("D"),
				  items: items.filter(item => moment(item.date*1000).format("YYYY-MM-DD").startsWith(ymd))
				}))
			  }))
			})
		  );
		return results;
	}

	toggleClass(key) {
        const currentState = this.state[key]; 
        this.setState( { ...this.state, [key]: !currentState });
    };
	
	renderPageData(filterDataOld) {
		if(filterDataOld){
			let filterData = this.formatData(filterDataOld);	
			let unique = 0;		
			let yearDiv = filterData.map((year) => {
				
				let monthDiv = year.months.map((month) => {
					let monthDivHeader = <div className="row col-12 margin-top-bottom-40 month-title-container"><h2>{month.month}</h2></div>;
					let daysDiv = month.days.map((days) => {
						let i = 0;
						
						let combinedDiv = days.items.map((api) => {
							let fromNowDate = moment(api.date*1000).fromNow();
							let dateString = moment(api.date*1000).format("YYYY-MM-DD");
					
							let comments = api.jiraComments.map((comments, index) => {
								return (
									<p key={index.toString()}>[{moment(comments.date*1000).format("YYYY-MM-DD HH:mm")}] {comments.text}</p>
								)
							})

							let description = api.jiraDescription.map((desc, index) => {
								return (
									<p key={index.toString()}>{desc}</p>
								)
							})

							let dateHeader =<h2 className="col-sm-1 incident-history-day">{i == 0 ? days.day : "" }</h2>;
							i = i + 1;
							unique = unique + 1;
							let uniqueToggleKey = api.jiraKey+unique.toString();
							let jiraServiceName = api.isManualIncident ? api.jiraSummary : api.service +" - "+ api.category;
							let statusClass= "border-warning";
							if(api.jiraStatus == "To Do"){
								statusClass = "border-gray";
							} else if(api.jiraStatus == "Blocked"){
								statusClass = "border-black";
							} else if(api.jiraStatus == "In Progress"){
								statusClass = "border-yellow";
							} else if(api.jiraStatus == "In Review"){
								statusClass = "border-blue";
							} else if(api.jiraStatus == "In Validation"){
								statusClass = "border-Cyan";
							} else if(api.jiraStatus == "Closed"){
								statusClass = "border-spring-green";
							} else if(api.jiraStatus == "Accepted"){
								statusClass = "border-green";
							} 
							let mainDiv = 
								<div className="col-sm-11 incident-history-item">
									<button className="shadow row incident-history-header collapses show" onClick = {(e) => this.toggleClass(uniqueToggleKey)} type="button">
										<div className="col-md-6 incident-history-title">{jiraServiceName} </div>
										<div className="col-md-3 incident-history-tracking-id">
                                    		Tracking ID: {api.jiraKey}
											{/* <a href={api.jiraTicket} target="_blank">{api.jiraKey}</a> */}
                                		</div>
										<div className="col-md-3 incident-history-chevron"><span className={`incident-border ${statusClass}`}>{api.jiraStatus.toUpperCase()}</span>  </div>
									</button>
									<div className="row">
										<div className={`incident-history-collapse collapses ${this.state[uniqueToggleKey] ? 'slideDown' : 'hide'}`} >
											<div className="card-body">
												<p><strong>What happened with the Service? </strong></p>
												<p>{description}</p>
												<p><strong>How did we respond? </strong> </p> {comments}
												<p><strong>Status:</strong>{api.jiraStatus}</p>
											</div>
										</div>
									</div>
								</div>;  
							
							return [dateHeader, mainDiv]
						})
						return combinedDiv;
					})
					return (
						[monthDivHeader,
						<div className="month-incident-container-wrapper">
							<div className="month-incident-container">
								<div className="row"> 
									{daysDiv} 
								</div>
							</div>
						</div>]
					);
				})
				return monthDiv;
			})
			return yearDiv;
		} else {
			return (
				<p>No Status Found.</p>					
			)
		}
	}

	serviceFilters(s3APIStatusJson) {		
		let filterArray = [];
		if(s3APIStatusJson){
			let temp = [];
			s3APIStatusJson.map((api, index) => {
				if(!temp.includes(api.service) && !api.isManualIncident){
					temp.push(api.service);
					filterArray.push(
						<option key={api.service} value={api.service}>{api.service}</option>
					);
				}
			})
			this.setState({ apiFilters: filterArray });
		} 
	}

	render() {
		let {selectedTimeline, selectedApiService} = this.state;
		let currentTimeStamp = moment().unix();
		let filterData = [];
		if(this.state.s3APIStatusJsonOriginal?.length > 0){
			this.state.s3APIStatusJsonOriginal.map((api) => {
				let last48Hours = moment().subtract({ hours: 48 }).unix();
				let last48HoursCheck = (api.date <= currentTimeStamp && api.date >= last48Hours);

				let last1Week = moment().subtract({ weeks: 1 }).unix();
				let last1WeekCheck = (api.date <= currentTimeStamp && api.date >= last1Week);

				let last30Days = moment().subtract({ days: 30 }).unix();
				let last30DaysCheck = (api.date <= currentTimeStamp && api.date >= last30Days);

				let last90Days = moment().subtract({ days: 90 }).unix();
				let last90DaysCheck = (api.date <= currentTimeStamp && api.date >= last90Days);

				let last6Months = moment().subtract({ months: 6 }).unix();
				let last6MonthsCheck = (api.date <= currentTimeStamp && api.date >= last6Months);

				let last1Year = moment().subtract({ years: 1 }).unix();
				let last1YearCheck = (api.date <= currentTimeStamp && api.date >= last1Year);

				let timecheck = true;
				if(selectedTimeline == "48"){
					timecheck = last48HoursCheck;
				}
				if(selectedTimeline == "week"){
					timecheck = last1WeekCheck;
				}
				if(selectedTimeline == "month"){
					timecheck = last30DaysCheck;
				}
				if(selectedTimeline == "90"){
					timecheck = last90DaysCheck;
				}
				if(selectedTimeline == "6month"){
					timecheck = last6MonthsCheck;
				}
				if(selectedTimeline == "year"){
					timecheck = last1YearCheck;
				}
				console.log("selectedTimeline", selectedTimeline, timecheck, selectedApiService, api.service)
				if ((timecheck) && (selectedApiService === "ALL" || api.service === selectedApiService)){
					filterData.push(api);
				};
			})
		}
		return (			
			<div className="container bootstrap-scope main-body-adjustment">
				<div className="w-100 px-5 mt-5">
					<div className="row">
						<div className="col col-6 col-md-6">
							<h2 id='title' className="justify-content-center">DDOA-DS Incidents History</h2>						
						</div>
						<div className="col col-6 col-md-6">
						<div className="row justify-content-center">
						
						</div>
						</div>
					</div>
					<div className="row history-dropdowns">
						<div className="col-lg-4">
							<p>Service:</p>
							<select name="wa-dropdown-service" id="selectReleases" onChange={this.handleApiChange} >
								<option key="ALL" value="ALL"> All </option>
								{this.state.apiFilters}								
							</select>
						</div>

						<div className="col-lg-4">
							<p>Time Line:</p>
							<select name="wa-dropdown-timeline" id="selectTimeline" defaultValue={"week"} onChange={this.handleTimelineChange} >
								<option value="48" >Last 48 hours</option>
								<option value="week">Last week</option>
								<option value="month" >Last month</option>
								<option value="90" >Last 90 days</option>
								<option value="6month" >Last 6 months</option>
								<option value="year" >Last 1 year</option>
							</select>
						</div>
					</div>
					<div id="history-results-container">
						{filterData.length == 0 ? <div className="row col history-no-results">
							<h3>There is no incident history information available for your selection.</h3>
						</div>: this.renderPageData(filterData)}
						
					</div>
				</div>
			</div>
		);
	}
}
